import { formatNumber, parseAmount } from '@blimo/shared';

/** API number → German input text ("250000" → "250.000,00"). */
const toInput = (value) => (value === null || value === undefined ? '' : formatNumber(value, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

/** API baseline → form values. @param {any} baseline */
export function baselineToForm(baseline) {
  return {
    purchase_price: toInput(baseline?.purchase_price),
    initial_rent: toInput(baseline?.initial_rent),
    initial_rental_income: toInput(baseline?.initial_rental_income),
    initial_costs: toInput(baseline?.initial_costs),
    purchase_month: baseline?.purchase_month ?? '',
  };
}

/** Form values → PUT payload (numbers, purchase_month "YYYY-MM" or null). @param {ReturnType<typeof baselineToForm>} values */
export function formToBaselinePayload(values) {
  return {
    purchase_price: parseAmount(values.purchase_price),
    initial_rent: parseAmount(values.initial_rent),
    initial_rental_income: parseAmount(values.initial_rental_income),
    initial_costs: parseAmount(values.initial_costs),
    purchase_month: values.purchase_month || null,
  };
}
